import SharedTransferenciaSection from '../_shared/TransferenciaSection';

// Mantenha em sincronia com lais-ai/src/agents/realestate/identity.js → DEFAULT_AGENT_CONFIG.transferencia
// i18nKey identifica a chave de tradução em settings:aiAgents.realstate.transferencia.gatilhos.<i18nKey> —
// mantido separado de `value` pra não acoplar o texto exibido ao identificador persistido/comparado no backend.
const GATILHOS_PREDEFINIDOS = [
    {
        value: 'cliente_interessado',
        i18nKey: 'clienteInteressado',
        title: 'Cliente gostou de um imóvel',
        description: 'Quando o cliente demonstra interesse em um imóvel apresentado (link, código ou sugestão).',
        icon: 'mdi:heart-outline',
    },
    {
        value: 'quer_atendente',
        i18nKey: 'querAtendente',
        title: 'Cliente pediu atendente humano',
        description: 'Quando o cliente diz "quero falar com alguém", "tem um corretor?", etc.',
        icon: 'mdi:account-tie-outline',
    },
    {
        value: 'sem_imoveis',
        i18nKey: 'semImoveis',
        title: 'Não encontrei imóveis',
        description: 'Quando a busca esgota tentativas de relaxamento sem encontrar opções no perfil pedido.',
        icon: 'mdi:home-search-outline',
    },
    {
        value: 'transfer_broker',
        i18nKey: 'transferBroker',
        title: 'Cliente quer mais opções (após N rodadas)',
        description: 'Quando o cliente continua pedindo "outras opções" após o limite de rodadas e a Lais envia o link completo.',
        icon: 'mdi:format-list-bulleted',
    },
];

/**
 * Wrapper do vertical imobiliário sobre a section compartilhada.
 *
 * O corpo foi extraído para `_shared/TransferenciaSection.js` sem mudança de
 * comportamento: `moduleKey='realstate'` (sem o 'e' — ver normalizeModuleKey em
 * AgenteAiDetails.js) e o `i18nBase` reproduz exatamente o prefixo das chaves
 * que já existem em settings.json, então nenhuma tradução muda.
 */
export default function TransferenciaSection({ aiAgent, changeModuleConfig }) {
    return (
        <SharedTransferenciaSection
            aiAgent={aiAgent}
            changeModuleConfig={changeModuleConfig}
            moduleKey="realstate"
            gatilhos={GATILHOS_PREDEFINIDOS}
            i18nBase="aiAgents.realstate.transferencia."
        />
    );
}
